import { Grid, VStack, Text } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'

import Widget from './Widget'

import { useData } from './constants'

function WidgetList(): React.ReactElement {
  const { t } = useTranslation('handout')

  const DATA = useData()

  return (
    <VStack
      spacing="5"
      layerStyle={{ base: 'container', md: '' }}
      sx={{
        alignItems: 'stretch',
        color: 'white',
        alignSelf: 'center',
        pt: 4,
        maxW: '100vw',
      }}
    >
      <Text
        as="h2"
        sx={{
          fontSize: { base: 'lg', sm: '2xl' },
          fontWeight: 'medium',
        }}
      >
        {t('contents.title')}
      </Text>
      <Grid
        sx={{
          gridTemplateColumns: {
            base: '1fr',
            md: 'repeat(2, 1fr)',
          },
          gridGap: {
            base: 5,
            sm: 7,
          },
        }}
      >
        {DATA.map((datum, index) => {
          return <Widget key={`${index}`} {...datum} />
        })}
      </Grid>
    </VStack>
  )
}

export default WidgetList
